import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }

import { useLocale } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { ref, watch } from 'vue';
import { useUserStore } from '@/store/user';

import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import en from 'element-plus/dist/locale/en.mjs';
import { useBus } from '@/common/utils/useBus';
interface LangType {
	name: string;
	value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectLanguage',
  props: {
	cssType: {
		type: String,
		default: '1'
	}
},
  setup(__props) {

const userBase = useUserStore();

const props = __props;

const langType: Array<LangType> = [
	{ name: '中文', value: 'zh' },
	{ name: 'English', value: 'en' }
];

const { locale } = useLocale();
const i18n = useI18n();

const { bus } = useBus();

const currentLanguage = ref(localStorage.getItem('lang') || 'zh');
watch(currentLanguage, () => {
	localStorage.setItem('lang', currentLanguage.value);
	if (currentLanguage.value == 'zh') {
		locale.value = zhCn;
		userBase.language = 'zh';
	} else {
		locale.value = en;
		userBase.language = 'en';
	}
	i18n.locale.value = currentLanguage.value;
	bus.emit('UPDATE_LANGUAGE');
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.cssType==1)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          class: "language_box1",
          modelValue: currentLanguage.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentLanguage).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(langType, (item) => {
              return _createVNode(_component_el_option, {
                key: item.value,
                label: item.name,
                value: item.value
              }, null, 8, ["label", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})